import React from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { Card, CardProps, NodeConfigProps } from './Card';
import { Input, InputProps } from './Input';
import { config } from '../index';

export interface FormProps extends CardProps {
  input?: InputProps[];
  inputConfig?: NodeConfigProps;
}

export interface InputWrapperProps extends InputProps {
  wrapperBorder?: string;
  wrapperBorderTop?: string;
  wrapperBorderBottom?: string;
  wrapperBorderLeft?: string;
  wrapperBorderRight?: string;
}

const StyledContentWrapper = styled.div<NodeConfigProps>`
  display: flex;
  flex-wrap: wrap;

  order: ${(props) => props.order};
  gap: ${(props) => props.gap};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  background-color: ${(props) => props.backgroundColor};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
`;

const StyledInputWrapper = styled.div<InputWrapperProps>`
  width: ${(props) => props.width};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  border: ${(props) => props.border};
  border-top: ${(props) => props.wrapperBorderTop};
  border-bottom: ${(props) => props.wrapperBorderBottom};
  border-left: ${(props) => props.wrapperBorderLeft};
  border-right: ${(props) => props.wrapperBorderRight};
  order: ${(props) => props.order};
`;

export const Form: React.FC<FormProps> = ({
  /* Input properties */
  input,
  /* Input config props */
  inputConfig,
  /* Additional props */
  ...props
}) => {
  // --------------------------------------------------------------------------------
  // 📌  From component. Extends Card.tsx
  // --------------------------------------------------------------------------------

  // 📌 don't return component if no properties values are specified
  if (!input) return null;

  return (
    <Card {...props}>
      {!!input?.length && (
        <StyledContentWrapper
          order={inputConfig?.order}
          gap={inputConfig?.gap}
          width={inputConfig?.width}
          margin={inputConfig?.margin}
          padding={inputConfig?.padding}
          backgroundColor={inputConfig?.backgroundColor}
          border={inputConfig?.border}
          borderRadius={inputConfig?.borderRadius}
        >
          {input.map((node, key) => {
            return (
              <StyledInputWrapper
                key={key}
                width="100%"
                margin={`${config.spacingXSmall} 0 0 0`}
                {...node}
              >
                <Input
                  value={node.value || ''}
                  onChange={node.onChange}
                  {...node}
                  // --------------------------------------------------------------------------------
                  width="100%" // overwrites input config passed to styled wrapper
                  padding="unset" // overwrites input config passed to styled wrapper
                  margin="unset" // overwrites input config passed to styled wrapper
                  className="" // overwrites input config passed to styled wrapper
                />
              </StyledInputWrapper>
            );
          })}
        </StyledContentWrapper>
      )}
    </Card>
  );
};
